import React, {useState} from 'react'
import './header.css'
import letters from '../../images/letters.png'
import sponsors from '../../images/sponsors.png'
import actors from '../../images/actors.png'
import actorsBackground from '../../images/fridge_background.png'
import open from '../../images/open.svg'
import circle from '../../images/circle.svg'
import cross from '../../images/cross.svg'

function Header() {

  let [ menu, setMenu ] = useState({ show: "close" })

  function handleMenu(change) {
    if (menu.show === "close") {
      setMenu({ show: "open" })
    } else if (menu.show === "open") {
      setMenu({ show: "close" })
    }
  }

  return (
    <header className='header'>
      <img src={open} alt="" className="menu__open" onClick={() => handleMenu("open")} />
      <div className="fiveplus__menu" style={ menu.show === "close" ? { display: "none" } : { display: "flex" }} >
        <div className="menu__close-button" onClick={() => handleMenu("close")}>
          <img className="menu__close-button-circle" src={circle} alt="circle"/>
          <img className="menu__close-button-cross" src={cross}  alt="cross"/>
        </div>
        <ul className="menu__list">
          <li className="menu__item"><a className="link" href="https://ok.ru/fiveplus/topic/153121147525940" target="_blank" onClick={() => handleMenu("close")}>смотреть</a></li>
          <li className="menu__item"><a className="link" href="#plot" onClick={() => handleMenu("close")}>сюжет</a></li>
          <li className="menu__item"><a className="link" href="#heroes" onClick={() => handleMenu("close")}>герои сериала</a></li>
          <li className="menu__item"><a className="link" href="#achievements" onClick={() => handleMenu("close")}>достижения</a></li>
        </ul>
      </div>
      <div className="header__container" id='top'>
        <nav className='header__navigation'>
          <ul className='header__navigation-list'>
            <li className='header__navigation-item'><a className="link" href="https://ok.ru/fiveplus/topic/153121147525940" target="_blank">смотреть</a></li>
            <li className='header__navigation-item'><a className="link" href="#plot">сюжет</a></li>
            <li className='header__navigation-item'><a className="link" href="#heroes">герои сериала</a></li>
            <li className='header__navigation-item'><a className="link" href="#achievements">достижения</a></li>
          </ul>
        </nav>
        <h1 className="header__title title"><a className="title__link" href="https://ok.ru/fiveplus" target="_blank">Сериал «Пять с плюсом» от Одноклассников</a></h1>
        <section className='header__images'>
          <img className='image_letters' src={letters} alt=""/>
          <img className='image_sponsors' src={sponsors} alt=""/>
          <img className='image_actors' width='730px' src={actors} alt=""/>
          <img className='image_actorsBackground' src={actorsBackground} alt=""/>
        </section>
        <section className="header__actors" id="watch">
          <h2 className="header__actor">Лукерья Ильяшенко</h2>
          <h2 className="header__actor">Артем Цуканов</h2>
          <h2 className="header__actor">Юлия Франц</h2>
          <h2 className="header__actor">Дмитрий Ендальцев</h2>
          <h2 className="header__actor">Артем Ешкин</h2>
        </section>
      </div>
    </header>
  )
}

export default Header

// <div className="menu__close-button" style={{ backgroundImage: 'url(../../images/close.svg)', backgroundSize: 'contain', width: '40px', height: '40px', zIndex: '60' }} />
